import React from "react";
import { IconProps } from "../index";
import { colors } from "src/assets";

const Index: React.FC<IconProps> = ({ color, size }) => {
  const localWidth = size * (20 / 24);
  const localHeight = size * (20.514 / 24);
  const localColor = color || colors.white;
  return (
    <svg width={localWidth} height={localHeight} viewBox="0 0 20 20.514">
      <path
        d="M.744,20.514A.744.744,0,0,1,0,19.77V6.844A.744.744,0,0,1,.744,6.1H9.256V2.959H7.62L10.012,0l2.4,2.959H10.744V6.1H19.25a.744.744,0,0,1,.744.744v.6a.745.745,0,0,1,0,.193V19.77a.744.744,0,0,1-.744.744Zm.744-1.488H18.505V9l-8.073,5.833a.744.744,0,0,1-.872,0L1.488,8.991ZM10,13.312l7.922-5.724H10.744v2a.744.744,0,1,1-1.488,0v-2H2.086Z"
        fill={localColor}
      />
    </svg>
  );
};

export default Index;
